import React from "react";
import IframePage from "./IframePage";
import "../../../css/BoletinOficial/decretos.css";

const Decretos = () => (
    <IframePage
      title="DECRETOS"
      description="Un gobierno abierto y transparente que pone a disposición de los ciudadanos información relevante para promover mayor participación y cercanía."
      iframeUrl="https://ciudaddeoliva.gov.ar/boletin-oficial/decretos.aspx"
      classPrefix="decretos"
    />
);

export default Decretos;
